import LegalLayout from "@/pages/LegalLayout";
import { SITE } from "@/lib/site";

export default function Impressum() {
  const L = SITE.legal;
  return (
    <LegalLayout title="Impressum">
      <h2>Angaben gemäß § 5 TMG</h2>
      <p>
        {L.name}<br />
        Reputationsmanagement<br />
        {L.street}<br />
        {L.city}
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: {L.phone}<br />
        Telefax: {L.fax}<br />
        E-Mail: <a href={`mailto:${L.email}`}>{L.email}</a>
      </p>

      <h2>Umsatzsteuer-ID / Steuernummer</h2>
      <p>StNr.: {L.stnr}</p>

      <h2>Berufsbezeichnung und berufsrechtliche Regelungen</h2>
      <p>
        Berufsbezeichnung: {L.role}<br />
        Verliehen in: Deutschland
      </p>

      <h2>Redaktionell verantwortlich</h2>
      <p>
        {L.name}<br />
        {L.street}<br />
        {L.city}
      </p>

      <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
      <p>
        Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucher­schlichtungsstelle teilzunehmen.
      </p>

      <h2>Haftungsausschluss</h2>
      <p>
        Diese Dienstleistung stellt keine Rechtsberatung dar und ersetzt nicht die Konsultation eines Fachanwalts. Meine Tätigkeit beschränkt sich auf die administrative Unterstützung beim strukturierten Meldeprozess von Online-Bewertungen über die offiziellen Plattformwege. Die Entscheidung über eine Entfernung liegt ausschließlich bei der jeweiligen Plattform.
      </p>
    </LegalLayout>
  );
}
